import type { OperatorDictionary } from './types';
import {
  textFormatter,
  singleNumericFormatter,
  rangeNumericFormatter,
  singleAbsoluteDateFormatter,
  rangeAbsoluteDateFormatter,
  rangeAbsoluteDateFormatterMonthDay,
  rangeRelativeDateFormatter,
  offsetRelativeDateFormatter,
  singleRelativeDateFormatter,
  valueSelectionFormatter,
 } from 'utils/valueFormatter/valueFormatter';
import { InputEnum, RelativeDateText, RelativeDateValue } from './types';

export const operatorDictionary: OperatorDictionary = {
  Contains: {
    text: {
      'Text': 'Contains',
      'TextArea': 'Contains',
      'ContentBlock': 'Contains',
    },
    inputType: {
      'Text': InputEnum.Text,
      'TextArea': InputEnum.Text,
      'ContentBlock': InputEnum.Text,
    },
    formatter: {
      'Text': textFormatter,
      'TextArea': textFormatter,
      'ContentBlock': textFormatter,
    },
  },
  NotContains: {
    text: {
      'Text': 'Does Not Contain',
      'TextArea': 'Does Not Contain',
      'ContentBlock': 'Does Not Contain',
    },
    inputType: {
      'Text': InputEnum.Text,
      'TextArea': InputEnum.Text,
      'ContentBlock': InputEnum.Text,
    },
    formatter: {
      'Text': textFormatter,
      'TextArea': textFormatter,
      'ContentBlock': textFormatter,
    },
  },
  Equals: {
    text: {
      'Text': 'Is',
      'TextArea': 'Is',
      'ContentBlock': 'Is',
      'Date': 'Is On',
      'Numeric': 'Exactly',
      'ValueSelection': 'Is',
    },
    inputType: {
      'Text': InputEnum.Text,
      'TextArea': InputEnum.Text,
      'ContentBlock': InputEnum.Text,
      'Date': InputEnum.Date,
      'Numeric': InputEnum.Number,
      'ValueSelection': InputEnum.BaseDropdown,
    },
    formatter: {
      'Text': textFormatter,
      'TextArea': textFormatter,
      'ContentBlock': textFormatter,
      'Numeric': singleNumericFormatter,
      'Date': singleAbsoluteDateFormatter,
      'ValueSelection': valueSelectionFormatter,
    },
  },
  NotEquals: {
    text: {
      'Text': 'Is Not',
      'TextArea': 'Is Not',
      'ContentBlock': 'Is Not',
      'Date': 'Is Not On',
      'Numeric': 'Is Not',
      'ValueSelection': 'Is Not',
    },
    inputType: {
      'Text': InputEnum.Text,
      'TextArea': InputEnum.Text,
      'ContentBlock': InputEnum.Text,
      'Date': InputEnum.Date,
      'Numeric': InputEnum.Number,
      'ValueSelection': InputEnum.BaseDropdown,
    },
    formatter: {
      'Text': textFormatter,
      'TextArea': textFormatter,
      'ContentBlock': textFormatter,
      'Numeric': singleNumericFormatter,
      'Date': singleAbsoluteDateFormatter,
      'ValueSelection': valueSelectionFormatter,
    },
  },
  GreaterThan: {
    text: {
      'Date': 'Is After',
      'Numeric': 'Over',
    },
    inputType: {
      'Date': InputEnum.Date,
      'Numeric': InputEnum.Number,
    },
    formatter: {
      'Numeric': singleNumericFormatter,
      'Date': singleAbsoluteDateFormatter,
    },
  },
  GreaterThanOrEqualTo: {
    text: {
      'Numeric': 'Is Greater Than or Equal To',
    },
    inputType: {
      'Numeric': InputEnum.Number,
    },
    formatter: {
      'Numeric': singleNumericFormatter,
    },
  },
  LessThan: {
    text: {
      'Date': 'Is Before',
      'Numeric': 'Under',
    },
    inputType: {
      'Date': InputEnum.Date,
      'Numeric': InputEnum.Number,
    },
    formatter: {
      'Numeric': singleNumericFormatter,
      'Date': singleAbsoluteDateFormatter,
    },
  },
  LessThanOrEqualTo: {
    text: {
      'Numeric': 'Is Less Than or Equal To',
    },
    inputType: {
      'Numeric': InputEnum.Number,
    },
    formatter: {
      'Numeric': singleNumericFormatter,
    },
  },
  Between: {
    text: {
      'Date': 'Is Between',
      'Numeric': 'Is Between',
    },
    inputType: {
      'Date': InputEnum.DateRange,
      'Numeric': InputEnum.NumberRange,
    },
    formatter: {
      'Numeric': rangeNumericFormatter,
      'Date': rangeAbsoluteDateFormatter,
    },
  },
  NotBetween: {
    text: {
      'Date': 'Is Not Between',
      'Numeric': 'Is Not Between',
    },
    inputType: {
      'Date': InputEnum.DateRange,
      'Numeric': InputEnum.NumberRange,
    },
    formatter: {
      'Numeric': rangeNumericFormatter,
      'Date': rangeAbsoluteDateFormatter,
    },
  },
  Checked: {
    text: {
      'CheckBox': 'Is Checked',
    },
    inputType: null,
  },
  NotChecked: {
    text: {
      'CheckBox': 'Is Not Checked',
    },
    inputType: null,
  },
  RadioOn: {
    text: {
      'RadioButton': 'Is True',
    },
    inputType: null,
  },
  RadioOff: {
    text: {
      'RadioButton': 'Is False',
    },
    inputType: null,
  },
  True: {
    text: {
      'Text': 'True',
    },
    inputType: null,
  },
  False: {
    text: {
      'Text': 'False',
    },
    inputType: null,
  },
  InCommaList: {
    text: {
      'Text': 'Is in a Comma Delimited List',
      'TextArea': 'Is in a Comma Delimited List',
      'ContentBlock': 'Is in a Comma Delimited List',
    },
    inputType: {
      'Text': InputEnum.TextArea,
      'TextArea': InputEnum.TextArea,
      'ContentBlock': InputEnum.TextArea,
    },
    formatter: {
      'Text': textFormatter,
      'Numeric': textFormatter,
      'TextArea': textFormatter,
      'ContentBlock': textFormatter,
    },
  },
  InList: {
    text: {
      'Text': 'Is in a List',
    },
    inputType: null,
  },
  NotInList: {
    text: {
      'Text': 'Is not in a List',
    },
    inputType: null,
  },
  NotInCommaList: {
    text: {
      'Text': 'Is Not in a Comma Delimited List',
      'TextArea': 'Is Not in a Comma Delimited List',
      'ContentBlock': 'Is Not in a Comma Delimited List',
    },
    inputType: {
      'Text': InputEnum.TextArea,
      'TextArea': InputEnum.TextArea,
      'ContentBlock': InputEnum.TextArea,
    },
    formatter: {
      'Text': textFormatter,
      'TextArea': textFormatter,
      'ContentBlock': textFormatter,
    },
  },
  IsEmpty: {
    text: {
      'Text': 'Has No Value',
      'TextArea': 'Has No Value',
      'ContentBlock': 'Has No Value',
      'Numeric': 'Is Unknown',
      'RadioButton': 'Is Undefined',
      'CheckBox': 'Is Undefined',
      'ValueSelection': 'Is Unknown',
      'Date': 'Has No Value',
    },
    inputType: null,
  },
  IsNotEmpty: {
    text: {
      'Text': 'Has Any Value',
      'TextArea': 'Has Any Value',
      'ContentBlock': 'Has Any Value',
      'Numeric': 'Has Any Value',
      'Date': 'Over all Time',
      'ValueSelection': 'Has Any Value',
    },
    inputType: null,
  },
  StartsWith: {
    text: {
      'Text': 'Starts With',
      'TextArea': 'Starts With',
      'ContentBlock': 'Starts With',
    },
    inputType: {
      'Text': InputEnum.Text,
      'TextArea': InputEnum.Text,
      'ContentBlock': InputEnum.Text,
    },
    formatter: {
      'Text': textFormatter,
      'TextArea': textFormatter,
      'ContentBlock': textFormatter,
    },
  },
  EndsWith: {
    text: {
      'Text': 'Ends With',
      'TextArea': 'Ends With',
      'ContentBlock': 'Ends With',
    },
    inputType: {
      'Text': InputEnum.Text,
      'TextArea': InputEnum.Text,
      'ContentBlock': InputEnum.Text,
    },
    formatter: {
      'Text': textFormatter,
      'TextArea': textFormatter,
      'ContentBlock': textFormatter,
    },
  },
  DaysFromToday: {
    text: {
      'Date': 'Within the Past',
    },
    inputType: {
      'DaysFromToday0': null,
      'DaysFromToday7': null,
      'DaysFromToday30': null,
      'DaysFromToday365': null,
      'DaysFromTodayNegative': InputEnum.LabeledNumberInput,
      'DaysFromTodayPositive': InputEnum.LabeledNumberInput,
    },
    formatter: {
      'Date': singleRelativeDateFormatter,
    },
  },
  DaysFromTodayMonthDay:  {
    text: {
      'Date': 'Within the Past',
    },
    inputType: {
      'DaysFromTodayMonthDay0': null,
    },
    formatter: {
      'Date': singleRelativeDateFormatter,
    },
  },
  MoreThanDaysFromToday: {
    text: {
      'Date': 'Is at Least',
    },
    inputType: {
      'Date': InputEnum.LabeledNumberInput,
    },
    formatter: {
      'Date': offsetRelativeDateFormatter,
    },
  },
  InBetweenDaysFromToday: {
    text: {
      'Date': '',
    },
    inputType: {
      'InBetweenDaysFromTodayNegative': InputEnum.LabeledNumberInputRange,
      'InBetweenDaysFromTodayPositive': InputEnum.LabeledNumberInputRange,
    },
    formatter: {
      'Date': rangeRelativeDateFormatter,
    },
  },
  NotInBetweenDaysFromToday: {
    text: {
      'Date': 'Is Not Between',
    },
    inputType: {
      'Date': InputEnum.LabeledNumberInputRange,
    },
    formatter: {
      'Date': rangeRelativeDateFormatter,
    },
  },
  InBetweenDaysFromTodayMonthDay: {
    text: {
      'Date': '',
    },
    inputType: {
      'InBetweenDaysFromTodayNegative': InputEnum.LabeledNumberInputRange,
      'InBetweenDaysFromTodayPositive': InputEnum.LabeledNumberInputRange,
    },
    formatter: {
      'Date': rangeRelativeDateFormatter,
    },
  },
  BetweenMonthDay: {
    text: {
      'Date': 'Is Between',
      'Numeric': 'Is Between',
    },
    inputType: {
      'Date': InputEnum.DateRange,
      'Numeric': InputEnum.NumberRange,
    },
    formatter: {
      'Numeric': rangeNumericFormatter,
      'Date': rangeAbsoluteDateFormatterMonthDay,
    },
  },
}

export const relativeDateTextDictionary: RelativeDateText = {
  DaysFromToday0: 'Today',
  DaysFromToday7: 'Is in the Last 7 Days',
  DaysFromToday30: 'Is in the Last 30 Days',
  DaysFromToday365: 'Is in the Last Year',
  DaysFromTodayPositive: 'In the Next',
  DaysFromTodayNegative: 'In the Last',
  DaysFromTodayMonthDay0: 'Is Today (MM/DD)',
  InBetweenDaysFromTodayNegative: 'Was Between',
  InBetweenDaysFromTodayPositive: 'Is Within the Next',
};

export const relativeDateValueDictionary: RelativeDateValue = {
  DaysFromToday0: '0',
  DaysFromToday7: '-7',
  DaysFromToday30: '-30',
  DaysFromToday365: '-365',
  DaysFromTodayMonthDay0: '0',
  InBetweenDaysFromTodayNegative: null,
  InBetweenDaysFromTodayPositive: null,
};

export const getRelativeDateText = (values: string[]): string => {
  if (values[0] === '0') {
    return relativeDateTextDictionary.DaysFromToday0;
  }

  return values[0].includes('-') ? relativeDateTextDictionary.DaysFromTodayNegative : relativeDateTextDictionary.DaysFromTodayPositive;
}
